import { render, staticRenderFns } from "./FbStatus.vue?vue&type=template&id=c928b6ac"
import script from "./FbStatus.vue?vue&type=script&lang=js"
export * from "./FbStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports